/*
 * @Author: dali
 * @Date: 2022-09-28 11:08:22
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2024-03-05 16:37:52
 * @FilePath: \gerlun-react-website\src\pages\case\particulars\index.jsx
 * @Description:
 */
import React, { useState, useEffect } from 'react'
import styles from './particulars.scss'
// import particulars_1 from '../../../common/images/case/particulars-1.jpg'
import User from '@/modules/user'
import { useParams } from 'react-router-dom'
import { VerticalAlignBottomOutlined } from '@ant-design/icons'

const CaseDtl = (props) => {
  const params = useParams()
  const id = params.id
  const user = new User()
  const [data, setData] = useState({})
  const [accessoryList, setAccessory] = useState([])
  const cutParticulars = (id) => {
    user.getArticleID(id)
      .then(res => {
        setData(res)
        setAccessory(res.resAttachDtoList)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  useEffect(() => {
    cutParticulars(id)
  }, [params])
  const download = (item) => {
    const docId = id
    const attachName = item.name
    user.downloadAttach(docId, attachName)
  }
  return <section className={styles['particulars']}>
    {/* <h2 className={styles['particulars-h2']}>{data.articleName}</h2> */}
    <div className={styles['particulars-content']} dangerouslySetInnerHTML = {{ __html: data.docContext }}></div>
    <div className={styles['accessory']}>
      { accessoryList ? accessoryList.map((val, index) => {
        return <div key={index} href='/#' className={styles['accessory-color']} onClick={(e) => e.preventDefault()}>
          <a href='/#' onClick={(e) => e.preventDefault()}>{val.name}</a>
          <a href='/#'><VerticalAlignBottomOutlined onClick={(e) => e.preventDefault() || download(val) } style={{ fontSize: '16px' }} /></a>
        </div>
      }) : null}
    </div>
  </section>
}

export default CaseDtl
